import { render } from "./company-systems.vue?vue&type=template&id=3c8f8a34&ts=true"
import script from "./company-systems.vue?vue&type=script&lang=ts"
export * from "./company-systems.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__